define([
	"dojo/_base/declare",
	"csi/table/New",
	"./MPPBOMSectionMixin"
], function(declare,New,MPPBOMSectionMixin) {

	return declare([New, MPPBOMSectionMixin], {});
});
